var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    className: "icon",
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 1.99413C19.9988 1.4641 19.8479 0.956249 19.5802 0.581457C19.3125 0.206665 18.9497 -0.00462593 18.5711 -0.00628662H1.42439C1.04657 -0.00296942 0.68497 0.209053 0.418227 0.583666C0.151484 0.95828 0.00117822 1.46519 0 1.99413V5.00001H20V1.99413Z",
    fill: "#97A7B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9996C0.00118623 18.5296 0.152111 19.0375 0.419824 19.4123C0.687536 19.7871 1.05029 19.9983 1.42889 20H18.5711C18.9497 19.9983 19.3125 19.7871 19.5802 19.4123C19.8479 19.0375 19.9988 18.5296 20 17.9996V7.99958H0V17.9996ZM6.33931 15H13.6607C13.8259 15.0005 13.9842 15.0924 14.1013 15.2555C14.2184 15.4186 14.2847 15.6399 14.2859 15.8711V15.8711C14.2855 16.1031 14.2195 16.3254 14.1024 16.4894C13.9852 16.6535 13.8264 16.7459 13.6607 16.7464H6.33931C6.17361 16.7459 6.0148 16.6535 5.89764 16.4894C5.78047 16.3254 5.71447 16.1031 5.71407 15.8711V15.8711C5.71526 15.6399 5.78161 15.4186 5.89869 15.2555C6.01577 15.0924 6.17412 15.0005 6.33931 15ZM3.12467 15H3.65994C3.82513 15.0005 3.98348 15.0924 4.10056 15.2555C4.21765 15.4186 4.28399 15.6399 4.28518 15.8711C4.28478 16.1031 4.21878 16.3254 4.10161 16.4894C3.98445 16.6535 3.82565 16.7459 3.65994 16.7464H3.12467C2.95897 16.7459 2.80017 16.6535 2.683 16.4894C2.56583 16.3254 2.49983 16.1031 2.49944 15.8711V15.8711C2.50062 15.6399 2.56697 15.4186 2.68405 15.2555C2.80114 15.0924 2.95949 15.0005 3.12467 15Z",
    fill: "#97A7B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment_icon.fd05659f.svg";
export { ForwardRef as ReactComponent };